import React from "react"
import moment from "moment"
import DataTableDisplayToggle from "./DataTableDisplayToggle"

export default class DataTable extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			dateFormat: 'YYYY-MM-DD',
			loading: false,
			pageLength: 10,
		}

		this.onChange = this.onChange.bind(this)
	}

	componentDidMount() {
		this.initDataTable();
	}

	componentDidUpdate(prevProps, prevState) {
		var self = this

		// do we need to re-calculate the startDate and endDate?
		if (prevProps.dateRange !== this.props.dateRange) {
			var dateRange = parseInt(this.props.dateRange);
			if (isNaN(dateRange)) {
				// custom date range
			} else {
				this.setState({
					startDate: moment().subtract(dateRange, 'days'),
					endDate: moment(),
				}, function () {
					self.datatable.ajax.reload();
				})
			}
		}

    // did the datatable render count change? if so, the parent component is telling us we need to reload the data
    if (prevProps.dataTableRenderCount !== this.props.dataTableRenderCount) {
      this.datatable.ajax.reload();
    }

		// did the dates change? should we reload the data?
		if (this.props.startDate && this.props.endDate && (!this.props.startDate.isSame(prevProps.startDate, 'day') || !this.props.endDate.isSame(prevProps.endDate, 'day'))) {
			this.datatable.ajax.reload();
		}

		// did pageLength change? if so, trigger it on the data table
		if (prevState.pageLength !== this.state.pageLength) {
			$('.dataTables_length select').val(this.state.pageLength).trigger('change')
		}
	}

	render() {
		var self = this;

		// console.log('DataTable', this.props, this.state);

		var columns = this.props.config.columns.map(function (column) {
			return <th key={column.data}>{I18n.t('admin.' + column.name)}</th>
		})

		return (
			<div className="DataTable">
				<div className="card">
					<div className="card-body">
	          <table className="table table-bordered dt-responsive nowrap" ref="datatable" style={{width: '100%'}}>
	          	<thead>
	          		<tr>
	          			{columns}
	          		</tr>
	          	</thead>
	          	<tbody></tbody>
	        	</table>
	        	<DataTableDisplayToggle onChange={this.onChange} pageLength={this.state.pageLength} />
					</div>				
				</div>
				{this.state.loading ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
			</div>
		)
	}

	/**
	* Change handlers
	*/ 

	onChange(event) {
		if (event && event.target && event.target.name) {
			// console.log('onChange', event.target.name, event.target.value);
			this.setState(Object.assign({}, this.state, { [event.target.name]: event.target.value }));
		}
	}

	/**
	* Helper functions
	*/

	initDataTable() {
		var self = this;

		if (this.datatable) {
			this.datatable.destroy();
		}

		var $datatable = $(this.refs.datatable)

		this.datatable = $datatable.DataTable({
			ajax: {
				url: self.props.endpoint,
				dataSrc: 'data',
				data: function (d) {
          if (self.props.startDate && self.props.endDate) {
            return { 
              start_date: self.props.startDate.format(self.state.dateFormat),
              end_date: self.props.endDate.format(self.state.dateFormat),
            }
          }
				}
			},
      deferRender: true,
			columns: this.props.config.columns,
			dom: 'ltp',
			language: {
				paginate: {
					previous: "«",
					next: "»",
				}
			},
		  order: this.props.config.order,
			paging: true,
			pageLength: this.state.pageLength,
			searching: false,
		});

		// event handling
		$datatable.on('preXhr.dt', function () {
			self.setState({loading: true})
		})

		$datatable.on('xhr.dt', function () {
			self.setState({loading: false})
		})
	}

}